export const PERMS = {
    READ: 'report_customer_weekly_plans.read',
    EXPORT: 'report_customer_weekly_plans.export',
}
